import React, { FunctionComponent, useRef, useEffect } from 'react';

import { BoardsSearch } from './BoardsSearch';
import styles from './QuickSwitcher.less';

import { Dialog, useDialog } from 'app/src/components/Dialog';
import { Key, Scope, useShortcut } from '@trello/keybindings';

export const QuickSwitcher: FunctionComponent = () => {
  const quickSwitcherInputRef = useRef<HTMLInputElement>(null);

  const {
    show: showDialog,
    hide: hideDialog,
    isOpen,
    dialogProps,
  } = useDialog();

  // set focus on quick switcher input when dialog opens
  useEffect(() => {
    if (isOpen) {
      quickSwitcherInputRef?.current?.focus();
    }
  }, [isOpen]);

  const onQuickSwitcherShortcut = () => {
    showDialog();
  };

  useShortcut(onQuickSwitcherShortcut, {
    scope: Scope.Global,
    key: Key.b,
  });

  const delayHideDialog = () => {
    // delay so that onSearchSubmit can execute & navigate
    window.setTimeout(hideDialog, 300);
  };

  const onKeyDownHandler = (e: React.KeyboardEvent) => {
    // close the dialog whenever you press enter on a result
    if (e.key === Key.Enter) {
      if (quickSwitcherInputRef?.current?.value === '') {
        // if there is no search text, prevent enter from submitting the form and going to a board
        e.preventDefault();
        e.stopPropagation();
      } else {
        delayHideDialog();
      }
    }
  };

  const onClickHandler = (e: React.MouseEvent) => {
    // close the dialog whenever you click on a result
    // don't close if you click in the search input
    if (e.target !== quickSwitcherInputRef.current) {
      delayHideDialog();
    }
  };

  return (
    <Dialog size="small" {...dialogProps}>
      {/* The event handlers are only being used to capture bubbled events
      in order to close the dialog at the appropriate times. */}
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        className={styles.quickSwitcherContainer}
        // eslint-disable-next-line react/jsx-no-bind
        onKeyDown={onKeyDownHandler}
        // eslint-disable-next-line react/jsx-no-bind
        onClick={onClickHandler}
      >
        <BoardsSearch ref={quickSwitcherInputRef} />
      </div>
    </Dialog>
  );
};
